import { $Q, $Qll } from "../utils/query-selector";

/**
 * Update the URL with the sort parameter.
 * Code recommended by shopify is used, it can be found at the following address
 * https://shopify.dev/themes/architecture/templates/collection#sort-products-in-a-collection
 * 
 * @author Andres Briñez
 */

export const sortBy = () => {
  Shopify.queryParams = {};

  // Update sort_by query parameter on select change
  $Q('#sort-by').addEventListener('change', function(e) {
    const value = e.target.value;

    Shopify.queryParams.sort_by = value;

    location.search = new URLSearchParams(Shopify.queryParams).toString();
  });
}


/**
 * Make the toggle of the open filters, this so as not to have multiple open filters
 * 
 * @author Andres Briñez
 */

export const filterToggle = (element) => {
  const details = $Qll(element);

  // Add the onclick listeners.
  details.forEach((targetDetail) => {
    targetDetail.addEventListener("click", () => {
      // Close all the details that are not targetDetail.
      details.forEach((detail) => {
        if (detail !== targetDetail) {
          detail.removeAttribute("open");
        }
      });
    });
  });
}

